<template>
  <div>

    <Loader v-if="isProcessing" cover/>

    <card-subject-info :classSectionId="$route.params.classSectionId" currentPage="HOME_WORK"></card-subject-info>

    <vx-card>
      <div class="vx-row mb-4">

        <div class="vx-col md:w-1/3 sm:w-1/2">
          <label class="text-sm opacity-75">{{ $t('student-assignment.assignment') }}</label>
          <v-select v-model="selectedClassAssignment" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :options="classAssignments"
                    label="topicLocal"
                    selectOnTab
                    @input="onClassAssignmentChange">

            <!--label option-->
            <template #selected-option="{ topicLocal }">
              {{ topicLocal }}
            </template>

            <!--option list-->
            <template v-slot:option="option">
              {{ option.topicLocal }}
            </template>

          </v-select>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/2">
          <label class="text-sm opacity-75">{{ $t('student-assignment.filter-teacher-receive') }}</label>
          <v-select v-model="selectedFilterTeacherReceive" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :options="filterTeacherReceive"
                    selectOnTab
                    @input="onFilterTeacherReceiveChange">
          </v-select>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/2">
          <vs-button @click="onDownloadAssigmentClick()"
                     class="float-right mt-5"
                     color="primary"
                     icon-pack="feather"
                     icon="icon-download">
            {{ $t('student-assignment.download-assignment') }}
          </vs-button>
        </div>

      </div>

      <vs-table-mod :data="studentEnrollDetailsFilter"
                    :max-items="selectedItemsPerPage"
                    pagination
                    search
      >
        <template slot="header-left">
          <div class="vx-col md:w-1/6 sm:w-full ">
            <v-select v-model="selectedItemsPerPage" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      :options="maxItemsPerPage"
                      class="mb-4 md:mb-0"
                      selectOnTab>
            </v-select>
          </div>
        </template>

        <template slot="header">
          <vx-tooltip :text="$t('general.back')">
            <vs-button
              class="ml-2"
              color="success" icon="icon-arrow-left" icon-pack="feather" radius type="filled"
              @click="onBackClick"></vs-button>
          </vx-tooltip>
        </template>

        <template v-for="(thead, indexth) in table.header"
                  slot="thead"
        >
          <vs-th :key="indexth" :sort-key="thead.id" :width="thead.width" class="text-center">
            {{ $t(thead.title) }}
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            v-for="(tr, indextr) in data"
            :key="indextr"
            :data="{ data: tr, index: indextr }"
          >
<!--            <vs-td>
              {{ tr.student.code }}
            </vs-td>-->
            <vs-td>
              <div class="flex items-center">
                <vs-avatar :src="getAvatarUrl(tr.student.picturePath)" class="flex-shrink-0 mr-2"
                           size="30px"
                />
                {{ tr.student.firstNameLocal + ' ' + tr.student.lastNameLocal }}
                <br>
                {{ tr.student.code }} <span v-if="tr.isDrop">({{ tr.dropType }})</span>
              </div>
            </vs-td>
            <vs-td>
              {{ $t('student-assignment.send-date') }} {{ formatDate(tr.studentSendDate) }}
              <br>
              {{ $t('student-assignment.receive-date') }} {{ formatDate(tr.teacherReceiveDate) }}
            </vs-td>
            <vs-td>
              <a v-if="tr.latitude != null && tr.longitude != null">
                <feather-icon class="cursor-pointer" icon="MapPinIcon"
                              svgClasses="w-5 h-5 text-primary stroke-current"
                              @click="onMapClick(tr.latitude, tr.longitude)"/>
              </a>
            </vs-td>
<!--            <vs-td>
            </vs-td>-->
            <vs-td>
              {{ tr.remark }}
              <br>
              <feather-icon v-if="tr.uploadPathUri"
                            class="ml-1 cursor-pointer" icon="DownloadIcon"
                            svgClasses="w-5 h-5 text-primary stroke-current"
                            @click="onDownloadClick(tr)"/>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vs-switch v-if="tr.studentAssignmentId"
                         v-model="tr.isTeacherReceive" color="success"
                         @input="onEditClick(tr)">
                <span slot="on">{{ $t('student-assignment.receive') }}</span>
                <span slot="off">{{ $t('student-assignment.reject') }}</span>
              </vs-switch>
            </vs-td>


          </vs-tr>
        </template>
      </vs-table-mod>

    </vx-card>

  </div>
</template>

<script>
import store from '@/store';
import {tableConfig} from '@/utils/table'
import {showStateNotification} from '@/utils/notification'
import moment from 'moment';
import {dateTimeFormat} from '@/utils/format';

import StudentAssignment from '@/store/modules/student-assignment/index';
import StudentEnrollDetail from '@/store/modules/student-enroll-detail/index';
import ClassAssignment from '@/store/modules/courses/class-assignment/index';
import {createHelpers} from 'vuex-map-fields';
import {createNamespacedHelpers} from "vuex";
import vSelect from "vue-select";
import {getAvatarUrl, config} from "@/utils/upload";
import CardSubjectInfo from "@/components/shared/card/CardSubjectInfo";
import {APIServerPrisma2} from "@/constants/config";

if (!store.state.StudentAssignment) store.state.registerModule(`StudentAssignment`, StudentAssignment);
if (!store.state.StudentEnrollDetail) store.state.registerModule(`StudentEnrollDetail`, StudentEnrollDetail);
if (!store.state.ClassAssignment) store.state.registerModule(`ClassAssignment`, ClassAssignment);

const {
  mapActions: mapClassAssignmentActions,
} = createNamespacedHelpers(`ClassAssignment`);
const {
  mapActions: mapStudentAssignmentActions,
} = createNamespacedHelpers(`StudentAssignment`);
const {
  mapActions: mapStudentEnrollDetailActions,
} = createNamespacedHelpers(`StudentEnrollDetail`);


const {
  mapFields: mapClassAssignmentFields,
} = createHelpers({
  getterType: `ClassAssignment/getField`,
  mutationType: `ClassAssignment/updateField`,
});
const {
  mapFields: mapStudentAssignmentFields,
} = createHelpers({
  getterType: `StudentAssignment/getField`,
  mutationType: `StudentAssignment/updateField`,
});
const {
  mapFields: mapStudentEnrollDetailFields,
} = createHelpers({
  getterType: `StudentEnrollDetail/getField`,
  mutationType: `StudentEnrollDetail/updateField`,
});

export default {
  props: {
    classSectionId: {
      type: String,
      require: true,
    }
  },
  components: {
    vSelect,
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
    CardSubjectInfo,
  },
  data() {
    return {
      moment: moment,
      dateTimeFormat: dateTimeFormat,
      getAvatarUrl: getAvatarUrl,
      table: {
        header: [
          // {title: 'live-class-schedule.no', id: 'no'},
          {title: 'student-assignment.student', id: 'studentCode', width: 220},
          // {title: 'student-enroll.student-name', id: 'studentName'},
          {title: 'student-assignment.send-receive-date', id: 'send', width: 220},
          {title: 'student-assignment.send-from', id: 'sendFrom', width: 220},
          // {title: 'student-assignment.receive-date', id: 'receive'},
          {title: 'student-assignment.desc', id: 'remark', width: 460},
          {title: 'student-assignment.receive', id: 'isEnabled', width: 150},
        ]
      },
      maxItemsPerPage: tableConfig.ddlItemsPerPage,
      selectedItemsPerPage: tableConfig.maxItemsPerPage,
      filterTeacherReceive: [
        this.$t('student-assignment.all'),
        this.$t('student-assignment.not-receive'),
        this.$t('student-assignment.received'),
        this.$t('student-assignment.not-send'),
      ],
      selectedFilterHasHomeWork: true,
      selectedFilterTeacherReceive: this.$t('student-assignment.all'),

      studentEnrollDetails: [],
      studentEnrollDetailsFilter: [],
      studentAssignments: [],
      classAssignments: [],
      selectedClassAssignment: null,
      isProcessing: true,
    }
  },
  computed: {
    ...mapClassAssignmentFields({classAssignmentProcessing: 'processing'}),
    ...mapStudentEnrollDetailFields({studentEnrollDetailProcessing: 'processing'}),
    ...mapStudentAssignmentFields({
      studentAssignmentProcessing: 'processing',
      studentAssignmentSuccess: 'success',
      studentAssignmentError: 'error'
    }),
  },
  watch: {
    classAssignmentProcessing(data) {
      this.isProcessing = data;
    },
    studentEnrollDetailProcessing(data) {
      this.isProcessing = data;
    },
    studentAssignmentProcessing(data) {
      this.isProcessing = data;
    },
    studentAssignmentSuccess(data) {
      showStateNotification(this.$vs, data);
    },
    studentAssignmentError(data) {
      showStateNotification(this.$vs, data);
    },
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapClassAssignmentActions({
      getClassAssignmentsByFilter: 'getClassAssignmentsByFilter',
    }),
    ...mapStudentAssignmentActions({
      getStudentAssignmentsByFilter: 'getStudentAssignmentsByFilter',
      updateStudentAssignmentTeacherReceive: 'updateStudentAssignmentTeacherReceive',
    }),
    ...mapStudentEnrollDetailActions({
      getStudentEnrollDetailsByFilterForHomeWork: 'getStudentEnrollDetailsByFilterForHomeWork',
    }),
    //---------------------------------------- Event Function ------------------------------------------------------//
    async onEditClick(tr) {
      let payload = {
        id: tr.studentAssignmentId,
        studentAssignmentInput: {
          isTeacherReceive: tr.isTeacherReceive
        }
      }

      let result = await this.updateStudentAssignmentTeacherReceive(payload);
      if (result) {
        let index = this.studentEnrollDetails.findIndex(item => item.id === result.studentEnrollDetail.id);
        this.studentEnrollDetails[index] = {
          ...this.studentEnrollDetails[index],
          studentAssignmentId: result.id,
          remark: result.remark,
          studentSendDate: result.studentSendDate,
          teacherReceiveDate: result.teacherReceiveDate,
          isTeacherReceive: result.isTeacherReceive,
          uploadPath: result.uploadPath,
          uploadPathUri: result.uploadPathUri,
          uploadFileName: result.uploadFileName,
          classAssignment: result.classAssignment
        }

        let indexFilter = this.studentEnrollDetailsFilter.findIndex(item => item.id === result.studentEnrollDetail.id);
        this.studentEnrollDetailsFilter[indexFilter] = {
          ...this.studentEnrollDetailsFilter[indexFilter],
          studentAssignmentId: result.id,
          remark: result.remark,
          studentSendDate: result.studentSendDate,
          teacherReceiveDate: result.teacherReceiveDate,
          isTeacherReceive: result.isTeacherReceive,
          uploadPath: result.uploadPath,
          uploadPathUri: result.uploadPathUri,
          uploadFileName: result.uploadFileName,
          classAssignment: result.classAssignment
        }

      }
    },
    onDownloadClick(tr) {
      let url = config.url.downloadFile + tr.uploadPathUri;
      window.open(url, '_blank');
    },
    onBackClick() {
      this.$router.push({
        name: 'home',
      })
    },
    onClassAssignmentChange() {
      this.studentEnrollDetailsFilter = this.filterClassAssignment();
    },
    onFilterTeacherReceiveChange() {
      this.studentEnrollDetailsFilter = this.filterClassAssignment();
    },
    onFilterHasHomeWorkClick() {
      this.studentEnrollDetailsFilter = this.filterClassAssignment();
    },
    onMapClick(latitude, longitude) {
      const geoUri = "http://maps.google.com/maps?q=loc:" + latitude + "," + longitude;
      //open new tab
      window.open(geoUri, '_blank');
    },
    onDownloadAssigmentClick() {
      this.isProcessing = true;

      const rsc = JSON.parse(localStorage.getItem("rsc"));
      let entity, stage
      if (rsc) {
        entity = rsc.e_code;
        stage = rsc.r_stage;
      }
      let url = APIServerPrisma2
        + '/api/export_excel_student_assignment'
        + '/' + this.$route.params.classSectionId
        + '/' + entity
        + '/' + stage;
      window.open(url, '_blank');

      this.isProcessing = false;
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    formatDate(date) {
      if (date) {
        return moment(date).format(dateTimeFormat.momentYYYYMMDDhhmmss)
      }
      return '-'
    },
    formatTime(date) {
      if (date) {
        return moment(date).format(dateTimeFormat.momenthhmmsss)
      }
      return '-'
    },
    filterClassAssignment() {
      const _this = this;

      let result = []
      //loop student
      this.studentEnrollDetails.forEach(item => {
        //assignment of current loop student
        let studentAssignments = _this.studentAssignments.filter(e => {
          return e.classAssignment.id === _this.selectedClassAssignment.id
            && e.studentCode === item.student.code
        });

        if(studentAssignments && studentAssignments.length > 0) {
          //add all assignment to array
          studentAssignments.forEach(assignment => {
            result.push({
              ...item,
              studentAssignmentId: assignment.id,
              remark: assignment.remark,
              studentSendDate: assignment.studentSendDate,
              teacherReceiveDate: assignment.teacherReceiveDate,
              isTeacherReceive: assignment.isTeacherReceive,
              uploadPath: assignment.uploadPath,
              uploadPathUri: assignment.uploadPathUri,
              uploadFileName: assignment.uploadFileName,
              classAssignment: assignment.classAssignment,
              latitude: assignment.latitude,
              longitude: assignment.longitude,
            });
          });
        }else {
          result.push(item);
        }
      });

      if(this.selectedFilterTeacherReceive ===  this.$t('student-assignment.not-receive')){
        result = result.filter(item => {
          return item.isTeacherReceive === false && item.uploadPathUri;
        })
      }else if (this.selectedFilterTeacherReceive ===  this.$t('student-assignment.received')){
        result = result.filter(item => {
          return item.isTeacherReceive === true;
        })
      }else if (this.selectedFilterTeacherReceive ===  this.$t('student-assignment.not-send')){
        result = result.filter(item => {
          return !item.studentAssignmentId;
        })
      }

      return result;
    },
    async initData() {
      let payload = {
        classAssignmentFilterInput: {
          classSectionId: this.$route.params.classSectionId,
        }
      };
      let result = await this.getClassAssignmentsByFilter(payload);

      this.classAssignments = result;

      if (result && result.length > 0) {
        this.selectedClassAssignment = result[0];
      }
    },
    async loadData() {

      let payload = {
        studentEnrollDetailFilterInput: {
          classSectionId: this.$route.params.classSectionId,
          // isDrop: false
        }
      };

      let result = await this.getStudentEnrollDetailsByFilterForHomeWork(payload);
      if (result) {
        this.studentEnrollDetails = result;
        // loop get studentAssignment
        let newArray = [];
        if (result.length > 0) {
          result.forEach(item => {
            if (item.studentAssignments && item.studentAssignments.length > 0) {
              newArray = newArray.concat(item.studentAssignments);
            }
          });
        }
        this.studentAssignments = newArray;

        this.studentEnrollDetailsFilter = this.filterClassAssignment();
      }
    },
  },
  async mounted() {
    await this.initData();
    await this.loadData();
  },
}
</script>

<style scoped>

</style>

